module.exports = __webpack_public_path__ + "static/img/19.ec21cdd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/1/zh/19.png
// module id = TisV
// module chunks = 0